import { Expose, Type } from "class-transformer";
import { CreateFileDto } from "../file/create-file.dto";
import { TransformToEntityReference } from "@/core/common/resource-base/transform-to-entity-reference";

export class CreateReferenceDocumentDto {
  @Expose()
  documentationTypeId: string;

  @Type(() => CreateFileDto)
  @Expose()
  file: CreateFileDto;

  @Expose({ name: "modelIds" })
  @TransformToEntityReference()
  models: string[];

  @Expose({ name: "elementIds" })
  @TransformToEntityReference()
  elements: string[];

  @Expose({ name: "interventionIds" })
  @TransformToEntityReference()
  interventions: string[];

  @Expose({ name: "clientGroupIds" })
  @TransformToEntityReference()
  clientGroups: string[];

  @Expose({ name: "workplaceIds" })
  @TransformToEntityReference()
  workplaces: string[];

  @Expose()
  downloadableByTechnicians: boolean;
}
